import React from 'react';
import { FaChevronLeft, FaChevronRight, FaPlus } from 'react-icons/fa';
import './PeriodNavigation.css';

export default function PeriodNavigation({
  year,
  quarter,
  isQuarterly,
  onYearChange,
  onQuarterChange,
  onPrev,
  onNext,
  onToggleType,
  onCreateOKR,
  showCreateButton = false
}) {
  const quarters = [
    { label: 'Q1', months: 'Jan–Mar' },
    { label: 'Q2', months: 'Apr–Jun' },
    { label: 'Q3', months: 'Jul–Sep' },
    { label: 'Q4', months: 'Oct–Dec' }
  ];
  
  const currentQuarter = quarters.find(q => q.label === quarter) || quarters[0];
  const periodDisplay = isQuarterly 
    ? `${quarter} ${year} — ${currentQuarter.months}`
    : `${year} — Annual`;
  
  return (
    <div className="m3-period-navigation">
      {/* LEFT: Create + Period Selector */}
      <div className="m3-period-left">
        {showCreateButton && onCreateOKR && (
          <button className="m3-button m3-button-filled m3-create-btn" onClick={onCreateOKR}>
            <FaPlus /> Create OKR
          </button>
        )}
        <select 
          className="m3-year-select"
          value={year}
          onChange={(e) => onYearChange && onYearChange(Number(e.target.value))}
        >
          {Array.from({ length: 10 }, (_, i) => year - 5 + i).map(y => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
        
        {isQuarterly && (
          <>
            <button className="m3-nav-button" onClick={onPrev} aria-label="Previous quarter">
              <FaChevronLeft />
            </button>
            <div className="m3-quarter-segmented">
              {quarters.map(q => (
                <button
                  key={q.label}
                  className={`m3-quarter-button ${quarter === q.label ? 'active' : ''}`}
                  onClick={() => onQuarterChange && onQuarterChange(q.label)}
                >
                  {q.label}
                </button>
              ))}
            </div>
            <button className="m3-nav-button" onClick={onNext} aria-label="Next quarter">
              <FaChevronRight />
            </button>
          </>
        )}
      </div>
      
      {/* CENTER: Period Display */}
      <div className="m3-period-display">
        {periodDisplay}
      </div>
      
      {/* RIGHT: Toggle */}
      <div className="m3-period-toggle">
        <label className="m3-toggle-option">
          <input
            type="radio"
            name="period-type"
            checked={!isQuarterly}
            onChange={() => onToggleType && onToggleType(false)}
          />
          <span>Annual</span>
        </label>
        <label className="m3-toggle-option">
          <input
            type="radio"
            name="period-type"
            checked={isQuarterly}
            onChange={() => onToggleType && onToggleType(true)}
          />
          <span>Quarter</span>
        </label>
      </div>
    </div>
  );
}

